var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateGroupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6519 16.6521H21.3039",
    stroke: "#8879A5",
    strokeWidth: 1.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8608 2.6958H2.6958V21.3041H13.8608",
    stroke: "#8879A5",
    strokeWidth: 1.67
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41748 6.41748H13.3956V10.1391H6.41748V6.41748Z",
    stroke: "#8879A5",
    strokeWidth: 1.67
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41748 14H13.3956V17.7217H6.41748V14Z",
    stroke: "#8879A5",
    strokeWidth: 1.67
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6519 21.3041H21.3039V5.02184L18.9779 2.6958L16.6519 5.02184V21.3041Z",
    stroke: "#8879A5",
    strokeWidth: 1.67
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateGroupIcon);
export default __webpack_public_path__ + "static/media/create_group_icon.e5cbaa735387d72bbc28b176723548d5.svg";
export { ForwardRef as ReactComponent };